<template>
  <carousel
    :per-page=1
    :autoplay=true
    :loop=true
    pagination-active-color="#aa6b2c"
    pagination-color="#7a7a75"
    easing="ease"
    autoplay-timeout=3000
    autoplay-hover-pause=true
    pagination-size=16
  >
    <slide>
      <h2 class="label">
        lighting repair &amp; <br>
        replacement
      </h2>
       <picture>
            <source
              media="(max-width: 480px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-square.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:481px) and (max-width:768px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-tablet.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:767px) and (max-width:1200px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-med.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1201px) and (max-width:1600px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-large.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1601px) and (max-width:1920px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-xlarge.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1921px)"
              srcset="../assets/shield-carousel/lighting-repair-replacement-01-xxlarge.jpg"
              alt="lighting repair replacement"
            />
            <img
              src="../assets/shield-carousel/lighting-repair-replacement-01.jpg"
              alt="lighting repair replacement"
            />
          </picture>

    </slide>
    <slide>
      <h2 class="label">
        filters &amp; ductwork<br>
        cleaned
      </h2>

      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-square.jpg"
          alt="tenant improvements"
        />
         <source
              media="(min-width:481px) and (max-width:768px)"
              srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-tablet.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:767px) and (max-width:1200px)"
              srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-med.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1201px) and (max-width:1600px)"
              srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-large.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1601px) and (max-width:1920px)"
              srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-xlarge.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1921px)"
              srcset="../assets/shield-carousel/filters-ductwork-cleaned-02-xxlarge.jpg"
              alt="lighting repair replacement"
            />
         <img
          src="../assets/shield-carousel/filters-ductwork-cleaned-02.jpg"
          alt="tenant improvements"
        />
      </picture>
      
     
    </slide>
    <slide>
      <h2 class="label">
        plumbing repair &amp; <br>
        drains cleared
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/shield-carousel/plumbing-repair-03-square.jpg"
          alt="sheetrock framing texture"
        />
        <source
              media="(min-width:481px) and (max-width:768px)"
              srcset="../assets/shield-carousel/plumbing-repair-03-tablet.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:767px) and (max-width:1200px)"
              srcset="../assets/shield-carousel/plumbing-repair-03-med.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1201px) and (max-width:1600px)"
              srcset="../assets/shield-carousel/plumbing-repair-03-large.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1601px) and (max-width:1920px)"
              srcset="../assets/shield-carousel/plumbing-repair-03-xlarge.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1921px)"
              srcset="../assets/shield-carousel/plumbing-repair-03-xxlarge.jpg"
              alt="lighting repair replacement"
            />
        <img
          src="../assets/shield-carousel/plumbing-repair-03.jpg"
          alt="sheetrock framing texture"
      >
      </picture>     
    </slide>

    <slide>
      <h2 class="label">
        roof repair &amp; <br>
        exterior maintenance
      </h2>
      <picture>
        <source
          media="(max-width: 480px )"
          srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-square.jpg"
          alt="demolition and sitework"
        />
         <source
              media="(min-width:481px) and (max-width:768px)"
              srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-tablet.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:767px) and (max-width:1200px)"
              srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-med.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1201px) and (max-width:1600px)"
              srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-large.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1601px) and (max-width:1920px)"
              srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-xlarge.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1921px)"
              srcset="../assets/shield-carousel/roof-repair-exterior-maintenance-06-xxlarge.jpg"
              alt="lighting repair replacement"
            />
        <img
          src="../assets/shield-carousel/roof-repair-exterior-maintenance-06.jpg"
          alt="demolition and sitework"
      >
      </picture>
    </slide>
    <slide>
      <h2 class="label">
        hvac &amp; mechanical<br>
        maintenance
      </h2>
      <picture>
        <source
          media="(max-width: 480px)"
          srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-square.jpg"
          alt="masonry concrete and tile"
        />
        <source
              media="(min-width:481px) and (max-width:768px)"
              srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-tablet.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:767px) and (max-width:1200px)"
              srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-med.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1201px) and (max-width:1600px)"
              srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-large.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1601px) and (max-width:1920px)"
              srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-xlarge.jpg"
              alt="lighting repair replacement"
            />
            <source
              media="(min-width:1921px)"
              srcset="../assets/shield-carousel/hvac-mechanical-maintenance-05-xxlarge.jpg"
              alt="lighting repair replacement"
            />
        <img
          src="../assets/shield-carousel/hvac-mechanical-maintenance-05.jpg"
          alt="masonry concrete and tile"
        />
      </picture>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "ShieldCarousel",
  components: {
    Carousel,
    Slide
  }
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";
@import "./src/stylesheets/ui/_carousel.scss";
</style>
